// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__bkWuX","productName":"Table_productName__31Dx3"};